import { AwardsApi } from '../clients';
import { mapReceivedFeedbackList } from '../mappers';
import { withNotFoundAs } from './notFound';

/**
 * Reads every review written about one member in a cycle, oldest first.
 *
 * "Nobody has reviewed them" is already a 200 with an empty array, so an empty
 * list is the normal quiet answer rather than a signal of anything. The two
 * 404s this endpoint can raise — unknown cycle, no membership — are only
 * reachable from a stale roster row and say the same thing, so they land on the
 * same empty list instead of an error the admin can do nothing about.
 */
export const getMemberReceivedFeedback = (cycleId, userId) =>
  withNotFoundAs([], async () =>
    mapReceivedFeedbackList(await AwardsApi.getMemberReceivedFeedback(cycleId, userId)));
